/**
 * @generated SignedSource<<bc225894ce9b08e81d64a0eba70ae72c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type UpdateOrgFlowStateSubscriptionInput = {
  flowStateRelayId: string;
};
export type UpdateOrgFlowStateSubscription$variables = {
  input: UpdateOrgFlowStateSubscriptionInput;
};
export type UpdateOrgFlowStateSubscription$data = {
  readonly updateOrgFlowState: {
    readonly flowState: {
      readonly id: string;
      readonly flowKey: string | null;
      readonly previousState: string | null;
      readonly current: {
        readonly state: string | null;
        readonly percentComplete: number | null;
        readonly errorMessage: string | null;
      } | null;
      readonly pending: {
        readonly state: string | null;
        readonly percentComplete: number | null;
        readonly errorMessage: string | null;
      } | null;
    } | null;
  };
};
export type UpdateOrgFlowStateSubscription = {
  variables: UpdateOrgFlowStateSubscription$variables;
  response: UpdateOrgFlowStateSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowKey",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousState",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentComplete",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateOrgFlowStateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrgFlowStateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "updateOrgFlowState",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowState",
            "kind": "LinkedField",
            "name": "flowState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "pending",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateOrgFlowStateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrgFlowStateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "updateOrgFlowState",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowState",
            "kind": "LinkedField",
            "name": "flowState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "pending",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c40271ed45a566bed77dddf067cc0a66",
    "id": null,
    "metadata": {},
    "name": "UpdateOrgFlowStateSubscription",
    "operationKind": "subscription",
    "text": "subscription UpdateOrgFlowStateSubscription(\n  $input: UpdateOrgFlowStateSubscriptionInput!\n) {\n  updateOrgFlowState(input: $input) {\n    flowState {\n      id\n      flowKey\n      previousState\n      current {\n        state\n        percentComplete\n        errorMessage\n        id\n      }\n      pending {\n        state\n        percentComplete\n        errorMessage\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2dc30e3bcbfbf9ef22ba02e91f6b533d";

export default node;
